export const split = (value) => {
  return value.split(/\s+/gi).filter((item) => item)
}
